module.exports = "<div class=\"container\">\n    <app-employees></app-employees>\n</div>"